import React, { useState } from 'react';
import TextField from 'shared/components/text-field/TextField';
import './PasswordField.scss';

const PasswordField = props => {
  const [showPassword, setShowPassword] = useState(false);
  const { error } = props || {};
  const name = props.name || 'password';
  const label = props.label || 'password';
  const togglePassword = () => {
    setShowPassword(!showPassword);
  };
  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      name={name}
      label={label}
      placeholder="*********"
      childTop={
        <label className="show-pass" onClick={togglePassword}>
          {showPassword ? 'Hide' : 'Show'}
        </label>
      }
      disabledTrim={true}
      error={error ? error : false}
    />
  );
};

export default PasswordField;
